import React from 'react';
import { string, object, oneOfType } from 'prop-types';
import PSPlaceholder from 'ps-components/Placeholder/Placeholder';
import './Placeholder.scss';

Placeholder.propTypes = {
  className: string,
  primaryClassName: string,
  secondaryClassName: string,
  containerClassName: string,
  primaryText: oneOfType([string, object]),
  secondaryText: oneOfType([string, object])
};

export default function Placeholder(props) {
  return (
    <PSPlaceholder
      className={'market-pricing__placeholder-container'}
      primaryText={props.primaryText}
      secondaryText={props.secondaryText}
      showText={true}
    />
  );
}
